<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
    ></b-loading>
    <div style="background: #eeeeee;padding-bottom: 120px">
      <div class="is-flex m-0 p-0">
        <div class="video-img" style="width: 50%; line-height: 0; position: relative">
          <video id="vid" ref="videoRef"
                 :src="selectedCalibration && selectedCalibration.videoUrl ? selectedCalibration.videoUrl : selectedDevice ? selectedDevice.videoUrl : ''"
                 @loadedmetadata="onVideoMetaDataLoaded" loop=""
                 preload="auto"
                 muted="" style="width: 100%;"></video>
          <div class="canvas-style" ref="canvas">
            <draw-on-video ref="videoDraw" @onDrawFinished="onDrawFinished" @onPlayVideo="onPlayPauseVideo"
                           :is-video-playing="isVideoPlaying" :is-video-loaded="videoLoaded"
                           @onDeleteImage="onDeleteImage" @onColorChanged="onColorChanged"
                           :video-start="getVideoStart()" :video-end="getVideoEnd()" @onVideoChanged="onVideoChanged"
                           :tabIndex="tabIndex"></draw-on-video>
          </div>
        </div>
        <div class="m-0 p-0 video-img" style="width: 50%; border: none">
          <draw-map ref="mapDraw" @onLinesDrawn="onLinesDrawn" :selected-tab="tabIndex"
                    :selected-approach="selectedApproach"
                    @onCrossingMapClick="onCrossingMapClick"></draw-map>
        </div>
      </div>
      <actions-bar ref="actionsBar" @onSaveData="saveData" @onCloseCalibration="onCloseCalibration"></actions-bar>
      <div v-if="selectedCalibration" class="m-4 mb-6 pb-6 box" style="min-height: 500px;">


        <div v-if="selectedApproach">
          <div class="is-flex is-flex-direction-row mb-3 has-background-light p-3">
            <div class="is-size-6 mt-auto mb-auto has-text-weight-semibold">Selected direction point:
              {{ this.selectedApproach.key }}
            </div>
            <b-button icon-left="close" size="is-small" class="ml-auto"
                      :disabled="!selectedCalibration"
                      @click="onSelectApproach(null)"></b-button>
          </div>
        </div>

        <b-tabs type="is-toggle" v-model="tabIndex" @input="onTabChanged">
          <b-tab-item label="Stage Polygons" icon="vector-polygon-variant">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="polygon in videoData.stagePolygons" :key="polygon.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-2 m-0 p-0">
                    <b-field label="Polygon Name" label-position="on-border" class="mr-2">
                      <b-input placeholder="Polygon Name" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.storeData.polyName" @input="onPolyDataChanged"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-4 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-2 m-0 p-0">
                    <div class="m-0 ml-3 p-0">
                      <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px;">CROSSING
                        DISTANCE
                      </div>
                      <div class="has-text-black has-text-weight-semibold" style="line-height: 1; font-size: 12px">
                        {{ polygon.storeData.crossingDistance ? polygon.storeData.crossingDistance : '-' }}
                      </div>
                    </div>
                  </div>
                  <div class="column is-4 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(polygon.id)"
                              @mouseleave="onLeave(polygon.id)" @click="onDelete(polygon.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Direction Points" icon="road-variant">
            <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
            <div class="card shadow mb-3" v-for="approach in videoData.approaches" :key="approach.id">
              <div class="is-flex p-3 pt-3 columns m-0">
                <div class="column is-3 m-0 p-0">
                  <b-field label="Direction Name" label-position="on-border" class="mr-2">
                    <b-input placeholder="ID" rounded type="text" size="is-small"
                             :disabled="!selectedCalibration || !selectedCalibration.isNew"
                             v-model="approach.key" @input="onApproachKeyChanged(approach.id, $event)"></b-input>
                  </b-field>
                </div>
                <div class="column is-3 m-0 p-0">
                  <b-field label="Coordinates" label-position="on-border" class="mr-2">
                    <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                             :disabled="!selectedCalibration || !selectedCalibration.isNew"
                             v-model="approach.value"></b-input>
                  </b-field>
                </div>
                <div class="column is-6 m-0 p-0 is-flex">
                  <b-button icon-left="check" size="is-small" class="ml-auto" @mouseover="onHover(approach.id)"
                            :disabled="!selectedCalibration"
                            @mouseleave="onLeave(approach.id)" @click="onSelectApproach(approach)"></b-button>
                  <b-button icon-left="delete" size="is-small" class="ml-3" @mouseover="onHover(approach.id)"
                            :disabled="!selectedCalibration || !selectedCalibration.isNew"
                            @mouseleave="onLeave(approach.id)" @click="onDelete(approach.id)"></b-button>
                </div>
              </div>
            </div>
            <div>Directions lookup</div>
            <div class="card shadow mb-3">
            <div class="is-flex p-3 pt-3 m-0 is-flex-wrap-wrap" v-if="directionLookup">
              <div class="m-0 p-0 mb-3" style="width: 25%" v-for="key in Object.keys(directionLookup)" :key="key">
                <b-field :label="key" label-position="on-border" class="mr-2">
                  <b-input placeholder="Direction" rounded type="text" size="is-small" @input="onDirectionsLookupChanged"
                           :disabled="!selectedCalibration || !selectedCalibration.isNew"
                           v-model="directionLookup[key]"></b-input>
                </b-field>
              </div>
            </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Direction Polygons" icon="vector-polygon-variant">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="polygon in videoData.directionPolygons" :key="polygon.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-2 m-0 p-0">
                    <b-field label="Direction Name" label-position="on-border" class="mr-2">
                      <b-input placeholder="Polygon Name" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.storeData.polyName" @input="onPolyDataChanged"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-4 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(polygon.id)"
                              :disabled="!selectedCalibration || !selectedCalibration.isNew"
                              @mouseleave="onLeave(polygon.id)" @click="onDelete(polygon.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Traffic Light Polygons" icon="traffic-light">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="polygon in videoData.trafficLightPolygons" :key="polygon.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-2 m-0 p-0">
                    <b-field label="Direction Name" label-position="on-border" class="mr-2">
                      <b-input placeholder="Polygon Name" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.storeData.polyName" @input="onPolyDataChanged"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-4 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(polygon.id)"
                              :disabled="!selectedCalibration || !selectedCalibration.isNew"
                              @mouseleave="onLeave(polygon.id)" @click="onDelete(polygon.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Crossing Config" icon="walk">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <!-- View Toggle for Crossing Config -->
              <div class="is-flex is-align-items-center mb-3 p-2 has-background-light" style="border-radius: 4px;">
                <span class="ml-0 has-text-grey" v-if="$refs.crossingConfig">
                  Mode: <strong>{{ $refs.crossingConfig.currentMode === 'crosswalk' ? 'Crosswalk' : 'Waiting Area' }}</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;Step: <strong>{{ getCrossingStepLabel() }}</strong>
                </span>
              </div>
              <!-- Crossing Config Component -->
              <crossing-config
                ref="crossingConfig"
                :video-src-width="videoSrcWidth"
                :video-src-height="videoSrcHeight"
                :canvas-width="$refs.videoDraw ? $refs.videoDraw.getSize().width : 0"
                :canvas-height="$refs.videoDraw ? $refs.videoDraw.getSize().height : 0"
                :is-editable="selectedCalibration && selectedCalibration.isNew"
                :initial-config="videoData.crosswalkConfig"
                @videoPointsChanged="onCrossingVideoPointsChanged"
                @mapPointsChanged="onCrossingMapPointsChanged"
                @drawingReset="onCrossingDrawingReset"
                @switchView="setCrossingViewMode"
                @configChanged="onCrossingConfigChanged"
                @redrawRequired="onCrossingRedrawRequired"
                @modeChanged="onCrossingModeChanged"
              ></crossing-config>
            </div>
          </b-tab-item>
          <b-tab-item :disabled="selectedApproach === null" label="Speed Lines" icon="vector-line">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="line in videoData.speedLines" :key="line.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-2 m-0 p-0">
                    <b-field label="Direction Name" label-position="on-border" class="mr-2">
                      <b-input placeholder="Polygon Name" rounded type="text" size="is-small"
                               :disabled="true"
                               v-model="line.storeData.approach" @input="onPolyDataChanged"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="line.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(line.id)"
                              :disabled="!selectedCalibration || !selectedCalibration.isNew"
                              @mouseleave="onLeave(line.id)" @click="onDelete(line.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Output" icon="code-json">
            <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
            <div class="is-flex p-3 pt-3 columns m-0">
              <div class="column is-6 m-0 p-0">
                <b-field label="Output" label-position="on-border" class="mr-2">
                  <b-input placeholder="OUTPUT" rounded type="textarea" size="is-small"
                           :disabled="!selectedCalibration || !selectedCalibration.isNew"
                           :value="getOutput()"></b-input>
                </b-field>
              </div>
              <div class="column is-6 m-0 p-0">
                <b-field label="Normalized Output" label-position="on-border" class="mr-2">
                  <b-input placeholder="NORMALIZED OUTPUT" rounded type="textarea" size="is-small"
                           :disabled="!selectedCalibration || !selectedCalibration.isNew"
                           :value="getNormalizedData()"></b-input>
                </b-field>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
      <div v-else class="m-4 pb-6 mt-5" style="min-height: 500px;">
        <video-calibrations @onCloneCalibration="onCloneCalibration"
                            @onEditCalibration="onEditCalibration"></video-calibrations>
      </div>
    </div>
  </div>
</template>
<script>
import DrawMap from "@/modules/data-processing-tmc-module/components/draw-map/draw-map.vue";
import DrawOnVideo from "@/modules/data-processing-tmc-module/components/draw-canvas/draw-on-video.vue";
import {distance, point} from "@turf/turf";
import {mapActions, mapGetters} from "vuex";
import VideoCalibrations
  from "@/modules/data-processing-tmc-module/components/video-calibrations/video-calibrations.vue";
import ActionsBar from "@/modules/data-processing-tmc-module/components/actions-bar/actions-bar.vue";
import CrossingConfig from "@/modules/data-processing-tmc-module/components/crossing-config/crossing-config.vue";
import {getDateTime, VideoCalibrationCategory} from "@/utils/utils";
import {nextTick} from "vue";

export default {
  name: "video-calibration-speed-page",
  components: {ActionsBar, VideoCalibrations, DrawMap, DrawOnVideo, CrossingConfig},
  props: {
    projectId: {
      type: String,
      required: true,
      default: '',
    },
    dataDeviceId: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      videoSrcWidth: 0,
      videoSrcHeight: 0,
      videoLoaded: false,
      tabIndex: -1,
      tabApproachIndex: -1,
      videoData: {
        stagePolygons: [],
        directionPolygons: [],
        trafficLightPolygons: [],
        dwellPolygons: [],
        speedLines: [],
        eventLines: [],
        approaches: [],
        measurements: [],
        geoLines: null,
        crossingDistanceGeoLines: null,
        speedDistances: [],
        crosswalkConfig: {
          zones: [],
          waitingAreas: [],
          directionMap: {}
        }
      },
      // Crossing config state
      crossingViewMode: 'video', // 'video' or 'map'
      crossingPendingPolygon: null, // Temp storage for polygon during geo mapping
      // Cache for original pixel crosswalkConfig from DB - prevents data loss during parseData cycles
      originalPixelCrosswalkConfig: null,
      storeData: null,
      isVideoPlaying: false,
      selectedApproach: null,
      directionLookup: null
    }
  },
  async mounted() {
    if (this.allProjects.length === 0) {
      this.isLoading = true
      await this.fetchAllProjects()
      let index = this.allProjects.findIndex(prj => prj._id === this.projectId)
      if (index !== -1) {
        await this.setSelectedProcessingProject(this.allProjects[index])

        //Find device data
        let deviceIndex = this.selectedProject.devices.findIndex(device => device._id === this.dataDeviceId)
        if (deviceIndex !== -1) {
          await this.setSelectedVideoCalibrations(this.selectedProject.devices[deviceIndex].videoCalibrations)
          await this.setSelectedProcessingDevice(this.selectedProject.devices[deviceIndex])
        }
      }

      this.isLoading = false

      console.log('Selected device: ', this.selectedDevice)
    }

    this.scrollToTop()
    this.video = document.getElementById("vid");
    this.timeout = null
    const observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const cr = entry.contentRect;
        console.log(`Element size: ${cr.width}px x ${cr.height}px`);
        let roundedWidth = Math.round(cr.width)
        let roundedHeight = Math.round(cr.height)

        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
          if (this.$refs.videoDraw) {
            this.$refs.videoDraw.setSize(roundedWidth, roundedHeight)
            this.$refs.mapDraw.setMapHeight(roundedHeight)
            this.videoSrcWidth = this.video.videoWidth
            this.videoSrcHeight = this.video.videoHeight
            console.log('Width&Height of video', this.videoSrcWidth, this.videoSrcHeight)
            this.$refs.videoDraw.setOriginalVideoDimensions(this.videoSrcWidth, this.videoSrcHeight)
            if (this.videoSrcWidth && this.videoSrcHeight) {
              this.isLoading = false
              // Re-parse data now that we have video dimensions (for crosswalkConfig conversion)
              this.parseData(this.storeData)
              // Load crossing config and draw zones
              this.loadCrossingConfigOnMount()
            }
          }
        }, 300);

      })
    })
    observer.observe(this.$refs.videoRef)

    this.convertAndSetData()
    this.parseData(this.storeData)
    //this.$refs.mapDraw.setFeature(this.storeData ? this.storeData.geoLines : null)

    this.$refs.mapDraw.setFeature(this.storeData && this.selectedApproach && this.storeData.geoLines ? this.storeData.geoLines[this.selectedApproach.key] : null)

    this.$refs.mapDraw.setCrossingDistanceFeature(this.storeData ? this.storeData.crossingDistanceGeoLines : null)
    this.isLoading = true
  },
  beforeDestroy() {

  },
  methods: {
    ...mapActions({
      selectCalibration: 'dataProcessingTmcModule/selectTmcCalibration',
      saveCalibration: 'dataProcessingTmcModule/saveTmcCalibration',
      editCalibration: 'dataProcessingTmcModule/editTmcCalibration',
      fetchAllProjects: 'projectsModule/getAllProjects',
      setSelectedProcessingProject: 'dataProcessingTmcModule/setTmcSelectedProcessingProject',
      setSelectedVideoCalibrations: 'dataProcessingTmcModule/setTmcSelectedVideoCalibrations',
      setSelectedProcessingDevice: 'dataProcessingTmcModule/setTmcSelectedProcessingDevice',
      getVideoUrl: 'dataProcessingTmcModule/getVideoUrl',
    }),
    async onSelectApproach(approach) {
      this.selectedApproach = approach
      this.tabIndex = 1
      this.$refs.mapDraw.setFeature(this.storeData && this.selectedApproach && this.storeData.geoLines ? this.storeData.geoLines[this.selectedApproach.key] : null)
      this.parseData(this.storeData)
      this.onTabChanged(this.tabIndex)
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async onVideoChanged(videoMetaData) {
      this.videoLoaded = false
      this.isLoading = true
      let response = await this.getVideoUrl(videoMetaData._id)
      if (response.errorMessage) {
        this.showToast(response.errorMessage, 'is-danger')
      } else {
        //this.showToast('Video Calibration successfully created', 'is-success')
        let selected = JSON.parse(JSON.stringify(this.selectedCalibration))
        selected.videoMetaDataId = response.videoMetaDataId
        selected.localCaptureStart = response.localCaptureStart
        selected.localCaptureEnd = response.localCaptureEnd
        selected.videoUrl = response.videoUrl
        await this.selectCalibration(selected)
        this.$refs.videoRef.src = selected.videoUrl
      }
    },
    onPlayPauseVideo() {
      if (this.isVideoPlaying) {
        this.isVideoPlaying = false
        this.$refs.videoRef.pause()
      } else {
        this.isVideoPlaying = true
        this.$refs.videoRef.play()
      }
    },
    onCloseCalibration() {
      this.tabIndex = 0
      this.onTabChanged(this.tabIndex)
      this.selectedApproach = null
      this.$refs.mapDraw.onClose()
    },
    getVideoStart() {
      if (this.selectedCalibration) {
        if (this.selectedCalibration.localCaptureStart) {
          return getDateTime(this.selectedCalibration.localCaptureStart, this.selectedDevice.site.timezone)
        }
        return '--:--'
      } else if (this.selectedDevice) {
        if (this.selectedDevice.localCaptureStart) {
          return getDateTime(this.selectedDevice.localCaptureStart, this.selectedDevice.site.timezone)
        }
      }

      return '--:--'
    },
    getVideoEnd() {
      if (this.selectedCalibration) {
        if (this.selectedCalibration.localCaptureEnd) {
          return getDateTime(this.selectedCalibration.localCaptureEnd, this.selectedDevice.site.timezone)
        }

        return '--:--'
      } else if (this.selectedDevice) {
        if (this.selectedDevice.localCaptureEnd) {
          return getDateTime(this.selectedDevice.localCaptureEnd, this.selectedDevice.site.timezone)
        }
      }

      return '--:--'
    },
    convertAndSetData() {
      if (this.selectedCalibration && this.selectedCalibration.pixelCalibration) {
        let data = JSON.parse(JSON.stringify(this.selectedCalibration.pixelCalibration))
        if (data && data.approaches) {
          let approachesList = []
          Object.keys(data.approaches).forEach(key => {
            let item = {}
            item[key] = data.approaches[key]
            approachesList.push(item)
          })
          data.approaches = approachesList
        }

        this.storeData = JSON.parse(JSON.stringify(data))
        console.log('Convert and set data: ', this.storeData)

        // Cache original pixel crosswalkConfig from DB to prevent data loss during parseData cycles
        if (data.crosswalkConfig) {
          this.originalPixelCrosswalkConfig = JSON.parse(JSON.stringify(data.crosswalkConfig))
          console.log('convertAndSetData - cached originalPixelCrosswalkConfig:', JSON.stringify(this.originalPixelCrosswalkConfig))
        } else {
          this.originalPixelCrosswalkConfig = null
        }
      } else {
        this.storeData = null
        this.originalPixelCrosswalkConfig = null
      }
    },
    getOutput() {
      console.log('Get output store: ', this.storeData)
      console.log('Get output video: ', this.videoData)
      let store = JSON.parse(JSON.stringify(this.storeData))
      if (store && store.approaches) {
        let dict = {};
        store.approaches.forEach(approach => {
          let key = Object.keys(approach)[0]
          dict[key] = approach[key]
        })
        store.approaches = dict
      }
      return JSON.stringify(store)
    },
    getNormalizedData() {
      let store = JSON.parse(JSON.stringify(this.storeData))

      if (store && store.approaches) {
        let dict = {};
        store.approaches.forEach(approach => {
          let key = Object.keys(approach)[0]
          dict[key] = approach[key]
        })
        store.approaches = dict
      }

      return JSON.stringify(this.normalize(store))
    },
    normalize(storeData) {
      if (this.videoSrcWidth && this.videoSrcHeight && storeData) {
        let normalizedData = JSON.parse(JSON.stringify(storeData))
        if (normalizedData.stagePolygons && normalizedData.stagePolygons.length > 0) {
          normalizedData.stagePolygons.forEach(polygon => {
            if (polygon.pts) {
              polygon.pts.forEach(pt => {
                pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
                pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
              })
            }

            console.log('POLY: ', polygon)

            if (polygon.crossingDistance) {
              polygon.crossingDistance = parseFloat(polygon.crossingDistance.toFixed(3))
            }
          })
        }

        if (normalizedData.directionPolygons && normalizedData.directionPolygons.length > 0) {
          normalizedData.directionPolygons.forEach(polygon => {
            if (polygon.pts) {
              polygon.pts.forEach(pt => {
                pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
                pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
              })
            }
          })
        }

        if (normalizedData.trafficLightPolygons && normalizedData.trafficLightPolygons.length > 0) {
          normalizedData.trafficLightPolygons.forEach(polygon => {
            if (polygon.pts) {
              polygon.pts.forEach(pt => {
                pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
                pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
              })
            }
          })
        }

        if (normalizedData.dwellPolygons && normalizedData.dwellPolygons.length > 0) {
          normalizedData.dwellPolygons.forEach(polygon => {
            if (polygon.pts) {
              polygon.pts.forEach(pt => {
                pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
                pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
              })
            }
          })
        }


        console.log('Speed lines: ', normalizedData.speedLines)

        if (normalizedData.speedLines && normalizedData.speedLines.length > 0) {
          normalizedData.speedLines.forEach(line => {
            if (line.line && line.line.length === 2) {
              line.line[0][0] = parseFloat((line.line[0][0] / this.videoSrcWidth).toFixed(3))
              line.line[0][1] = parseFloat((line.line[0][1] / this.videoSrcHeight).toFixed(3))
              line.line[1][0] = parseFloat((line.line[1][0] / this.videoSrcWidth).toFixed(3))
              line.line[1][1] = parseFloat((line.line[1][1] / this.videoSrcHeight).toFixed(3))
            }
          })
        }

        console.log('Speed lines: ', normalizedData.speedLines)

        if (normalizedData.eventLines && normalizedData.eventLines.length > 0) {
          normalizedData.eventLines.forEach(line => {
            if (line.length === 2) {
              line[0][0] = parseFloat((line[0][0] / this.videoSrcWidth).toFixed(3))
              line[0][1] = parseFloat((line[0][1] / this.videoSrcHeight).toFixed(3))
              line[1][0] = parseFloat((line[1][0] / this.videoSrcWidth).toFixed(3))
              line[1][1] = parseFloat((line[1][1] / this.videoSrcHeight).toFixed(3))
            }
          })
        }

        if (normalizedData.approaches) {
          normalizedData.speedByPolygon = {}
          Object.keys(normalizedData.approaches).forEach(key => {
            normalizedData.approaches[key][0] = parseFloat((normalizedData.approaches[key][0] / this.videoSrcWidth).toFixed(3))
            normalizedData.approaches[key][1] = parseFloat((normalizedData.approaches[key][1] / this.videoSrcHeight).toFixed(3))

            let directionPolygon = normalizedData.directionPolygons.find(ln => ln.polyName === key)
            let speedLinesPerApproach = normalizedData.speedLines.filter(ln => ln.approach === key)
            let lines = speedLinesPerApproach.map(ln => ln.line)

            let distancesPerApproach = normalizedData.speedDistances.find(dst => dst.approach === key)
            //let distances = distancesPerApproach.map(dst => dst.distances)

            //console.log('Distances: ', distances)
            console.log('Distance per aproach: ', distancesPerApproach)

            normalizedData.speedByPolygon[key] = {
              speedLines: [...lines],
              distance: distancesPerApproach && distancesPerApproach.distances ? distancesPerApproach.distances : [],
              polyPts: directionPolygon ? directionPolygon.pts : null,
              dirPt: [normalizedData.approaches[key][0], normalizedData.approaches[key][1]]
            }
          })
        }


        delete normalizedData.geoLines
        delete normalizedData.crossingDistanceGeoLines
        delete normalizedData.isNew

        let allNormData = JSON.parse(JSON.stringify(normalizedData))
        delete allNormData.approaches
        delete allNormData.directionPolygons
        delete allNormData.speedLines
        delete allNormData.dwellPolygons
        delete allNormData.speedDistances
        delete allNormData.eventLines

        // CrosswalkConfig coordinates are already normalized (0-1 relative)
        // No conversion needed, just include as-is
        if (normalizedData.crosswalkConfig) {
          allNormData.crosswalkConfig = normalizedData.crosswalkConfig
        }

        console.log('All normalized data: ', allNormData)
        //return normalizedData
        return allNormData
      }
      return null
    },
    async saveData() {
      console.log('On save data')
      if (this.videoSrcWidth && this.videoSrcHeight) {

        // Sync crosswalkConfig from crossing-config component before saving
        if (this.$refs.crossingConfig) {
          const latestCrosswalkConfig = this.$refs.crossingConfig.getConfig()
          console.log('saveData - syncing crosswalkConfig from component:', JSON.stringify(latestCrosswalkConfig))
          this.videoData.crosswalkConfig = latestCrosswalkConfig
        }

        this.setStoreData()
        let saveData = JSON.parse(JSON.stringify(this.storeData))

        let dict = {};
        saveData.approaches.forEach(approach => {
          let key = Object.keys(approach)[0]
          dict[key] = approach[key]
        })
        saveData.approaches = dict


        let pixelCrossingConfigResult
        // Convert crosswalkConfig from relative (0-1) to pixel coordinates for pixelCalibration
        if (saveData.crosswalkConfig) {
          const pixelCrosswalkConfig = JSON.parse(JSON.stringify(saveData.crosswalkConfig))

          console.log('saveCalibration - crosswalkConfig before pixel conversion:', JSON.stringify(pixelCrosswalkConfig))
          console.log('saveCalibration - videoSrcWidth:', this.videoSrcWidth, 'videoSrcHeight:', this.videoSrcHeight)

          // Convert zone polygons and lines to pixel
          if (pixelCrosswalkConfig.zones) {
            pixelCrosswalkConfig.zones.forEach(zone => {
              if (zone.polygon) {
                zone.polygon = zone.polygon.map(p => [
                  Math.round(p[0] * this.videoSrcWidth),
                  Math.round(p[1] * this.videoSrcHeight)
                ])
              }
              if (zone.lines) {
                zone.lines = zone.lines.map(line => [
                  [Math.round(line[0][0] * this.videoSrcWidth), Math.round(line[0][1] * this.videoSrcHeight)],
                  [Math.round(line[1][0] * this.videoSrcWidth), Math.round(line[1][1] * this.videoSrcHeight)]
                ])
              }
              // geoPolygon stays as-is (geo coordinates)
            })
          }

          // Convert waiting area polygons to pixel
          if (pixelCrosswalkConfig.waitingAreas) {
            pixelCrosswalkConfig.waitingAreas.forEach(area => {
              if (area.polygon) {
                area.polygon = area.polygon.map(p => [
                  Math.round(p[0] * this.videoSrcWidth),
                  Math.round(p[1] * this.videoSrcHeight)
                ])
              }
              // geoPolygon stays as-is (geo coordinates)
            })
          }

          console.log('saveCalibration - crosswalkConfig AFTER pixel conversion:', JSON.stringify(pixelCrosswalkConfig))
          pixelCrossingConfigResult = pixelCrosswalkConfig
        }

        let normalized = this.normalize(saveData)


        let payload = JSON.parse(JSON.stringify(this.selectedCalibration))

        payload.pixelCalibration = saveData
        payload.pixelCalibration.crosswalkConfig = pixelCrossingConfigResult
        payload.calibration = normalized

        //set direction lookup
        payload.directionLookup = this.directionLookup


        delete payload.validFromPicker
        delete payload.validToPicker
        delete payload.isNew
        delete payload.localCaptureStart
        delete payload.localCaptureEnd
        delete payload.availableFiles
        delete payload.videoUrl

        if (payload.calibration === null) {
          this.showToast('Normalized calibration not created. ', 'is-danger')
        }


        console.log('Save payload: ', payload)



        this.isLoading = true

        if (payload.isEdit) {
          console.log('Is edit: ', true)
          delete payload.isEdit
          let response = await this.editCalibration(payload)
          if (response.errorMessage) {
            this.showToast(response.errorMessage, 'is-danger')
          } else {
            this.showToast('Video Calibration successfully updated', 'is-success')
            await this.selectCalibration(null)
          }
        } else {
          let response = await this.saveCalibration(payload)
          if (response.errorMessage) {
            this.showToast(response.errorMessage, 'is-danger')
          } else {
            this.showToast('Video Calibration successfully created', 'is-success')
            await this.selectCalibration(null)
          }
        }


        this.isLoading = false
        this.onCloseCalibration()
        console.log('SAve Payload: ', payload)
      } else {
        this.showToast('Can not create calibration. Video is not loaded correctly.', 'is-danger')
      }
    },
    onLinesDrawn(features) {

      if (this.tabIndex === 5) {
        console.log('Features new: ', features)
        if (this.videoData && this.videoData.geoLines == null) {
          this.videoData.geoLines = {}
        }
        this.videoData.geoLines[this.selectedApproach.key] = features
        let allDrawings = this.videoData.geoLines[this.selectedApproach.key]

        let groupedFeatures = {}
        allDrawings.features.forEach(feature => {
          let split = feature.id.split("_")
          if (split.length > 0) {
            const approach = split[split.length - 1]
            if (groupedFeatures[approach] == null) {
              groupedFeatures[approach] = []
            }

            groupedFeatures[approach].push(feature)
          }
        })

        console.log('GAll drawings: ', allDrawings)
        console.log('Grouped drawings: ', groupedFeatures)

        let linePairs = []
        let pickedDistances = []
        if (allDrawings && allDrawings.features && allDrawings.features.length > 1) {
          let features = allDrawings.features
          for (let i = 0; i < features.length - 1; i++) {
            linePairs.push({first: features[i].geometry.coordinates, second: features[i + 1].geometry.coordinates})
          }
        }

        if (linePairs.length > 0) {
          let options = {units: "kilometers"};
          linePairs.forEach(linePair => {
            let distOne = distance(point(linePair.first[0]), point(linePair.second[0]), options);
            let distTwo = distance(point(linePair.first[0]), point(linePair.second[1]), options);

            let pick = distOne < distTwo ? distOne : distTwo
            pick = parseFloat((pick * 1000.0).toFixed(3))

            pickedDistances.push(pick)
            console.log('Distance: ', `First dist ${distOne} km, Second dist ${distTwo} PICK: ${pick}m`)
          })
        }


        let index = this.videoData.speedDistances.findIndex(dist => dist.approach === this.selectedApproach.key)
        console.log('Speed distances 1: ', this.videoData.speedDistances)
        console.log('Speed distances picked: ', pickedDistances)
        if (index !== -1) {
          console.log('Speed distances 2: ', index)
          this.videoData.speedDistances[index].distances = pickedDistances
        } else {
          this.videoData.speedDistances.push({
            approach: this.selectedApproach.key,
            distances: pickedDistances
          })
        }

        //this.videoData.speedDistances = pickedDistances
      } else if (this.tabIndex === 0) {
        this.videoData.crossingDistanceGeoLines = features

        let allDrawings = this.videoData.crossingDistanceGeoLines
        console.log('All Drivings Crossing', allDrawings)

        this.videoData.stagePolygons.forEach(poly => {
          poly.storeData.crossingDistance = null
        })

        if (allDrawings && allDrawings.features && allDrawings.features.length > 0) {
          allDrawings.features.forEach(feature => {
            let options = {units: "kilometers"};
            let coordinates = feature.geometry.coordinates
            let dist = distance(point(coordinates[0]), point(coordinates[1]), options);
            dist = parseFloat((dist * 1000.0).toFixed(3))

            let polyIndex = this.videoData.stagePolygons.findIndex(polygon => polygon.id === feature.id)
            if (polyIndex !== -1) {
              this.videoData.stagePolygons[polyIndex].storeData.crossingDistance = dist
            }
          })
        }
      }

      this.refreshData()
    },
    setStoreData() {
      console.log('Set store data video 0: ', this.videoData)
      console.log('setStoreData - crosswalkConfig being copied:', JSON.stringify(this.videoData.crosswalkConfig))
      let oldStoreData = JSON.parse(JSON.stringify(this.storeData))

      let speedLinesNew = []
      if (oldStoreData) {
        console.log('Old store data: ', oldStoreData)
        let newSpeedVideoData = this.videoData.speedLines.map(line => line.storeData)
        if (this.selectedApproach) {
          speedLinesNew = oldStoreData.speedLines.filter(data => data.approach !== this.selectedApproach.key)
          console.log('Speed lines approach: ', speedLinesNew)
          speedLinesNew.push(...newSpeedVideoData)
        } else {
          speedLinesNew = oldStoreData.speedLines
        }
      }

      this.storeData = {
        stagePolygons: this.videoData.stagePolygons.map(poly => poly.storeData),
        directionPolygons: this.videoData.directionPolygons.map(poly => poly.storeData),
        trafficLightPolygons: this.videoData.trafficLightPolygons.map(poly => poly.storeData),
        dwellPolygons: this.videoData.dwellPolygons.map(poly => poly.storeData),
        //TODO merge store data per approach
        speedLines: speedLinesNew,
        eventLines: this.videoData.eventLines.map(eLine => eLine.storeData),
        approaches: this.videoData.approaches.map(approach => approach.storeData),
        speedDistances: this.videoData.speedDistances,
        geoLines: this.videoData.geoLines,
        crossingDistanceGeoLines: this.videoData.crossingDistanceGeoLines,
        crosswalkConfig: this.videoData.crosswalkConfig
      }

      console.log('Set store data: ', this.storeData)
      console.log('Set store data video 1: ', this.videoData)

      this.setDirectionLookup()

    },
    setDirectionLookup(){
      if(!this.directionLookup){
        this.directionLookup = {}
      }

      if(this.videoData && this.videoData.approaches){
        const appNames = this.videoData.approaches.map(ap => ap.key)
        if(appNames.length > 0){
          const keys = appNames.flatMap(a =>
              appNames.filter(b => b !== a).map(b => a + b)
          );

          if(keys.length > 0){
            keys.forEach(key => {
              if(this.directionLookup && !this.directionLookup[key]){
                if(this.selectedDevice.directionLookup && this.selectedDevice.directionLookup[key]){
                  this.directionLookup[key] = this.selectedDevice.directionLookup[key]
                }else{
                  this.directionLookup[key] = null
                }
              }
            })
          }

          for (const key of Object.keys(this.directionLookup)) {
            if (!keys.includes(key)) {
              delete this.directionLookup[key];
            }
          }


        }
      }
    },
    refreshData() {
      if (this.videoData && this.videoSrcWidth !== 0 && this.videoSrcHeight !== 0 && this.selectedCalibration) {
        setTimeout(() => {
          this.setStoreData()
          console.log('Refresh data: ', this.storeData)
          this.parseData(this.storeData)
        }, 500)
      }
    },
    onColorChanged() {
      this.refreshData()
    },
    onHover(imageId) {
      this.$refs.videoDraw.onDeleteHover(imageId)
    },
    onLeave(imageId) {
      this.$refs.videoDraw.onDeleteLeave(imageId)
    },
    onDelete(imageId) {
      if (this.selectCalibration && this.selectedCalibration.isNew) {
        this.$refs.videoDraw.onDelete(imageId)
      }
    },
    onApproachKeyChanged(imageId, event) {
      console.log('Approach key changed', imageId, event)

      let index = this.videoData.approaches.findIndex(app => app.id === imageId)
      if (index !== -1) {
        let oldData = JSON.parse(JSON.stringify(this.videoData.approaches[index].storeData))
        let obj = {}
        obj[event] = Object.values(oldData)[0]
        this.videoData.approaches[index].storeData = obj
        this.videoData.approaches[index].key = event
        this.videoData.approaches[index].value = JSON.stringify(Object.values(oldData)[0])
        this.videoData.approaches[index].drawData.text = event
      }

      let allDrawData = [
        ...this.videoData.stagePolygons.map(poly => poly.drawData),
        ...this.videoData.directionPolygons.map(poly => poly.drawData),
        ...this.videoData.trafficLightPolygons.map(poly => poly.drawData),
        ...this.videoData.dwellPolygons.map(poly => poly.drawData),
        ...this.videoData.speedLines.map(line => line.drawData),
        ...this.videoData.eventLines.map(eLine => eLine.drawData),
        ...this.videoData.approaches.map(app => app.drawData),
        ...this.videoData.measurements
      ]

      this.setStoreData()

      console.log('All DATA: ', allDrawData)

      this.$refs.videoDraw.setInputData(allDrawData)
    },
    onPolyDataChanged() {
      this.$nextTick(() => {
        this.setStoreData()
      })
    },
    onDirectionsLookupChanged() {
      this.$nextTick(() => {
        console.log('On directions lookup changed: ', this.directionLookup)
      })
    },
    parseData(storeData, selectedCategory) {
      console.log('Video json', storeData)

      let currentWidth = this.$refs.videoDraw.getSize().width
      let currentHeight = this.$refs.videoDraw.getSize().height

      let diffX = currentWidth / this.videoSrcWidth
      let diffY = currentHeight / this.videoSrcHeight

      let settings = this.$refs.videoDraw.getSettings()

      console.log('Video json 2: ', this.videoData)

      // Convert crosswalkConfig from pixel to relative coordinates (0-1)
      // IMPORTANT: Use cached originalPixelCrosswalkConfig to prevent data loss during parseData cycles
      // The originalPixelCrosswalkConfig is set in convertAndSetData when loading from DB
      let loadedCrosswalkConfig = {
        zones: [],
        waitingAreas: [],
        directionMap: {}
      }
      // Use cached original config if available, otherwise fall back to storeData
      const pixelConfigSource = this.originalPixelCrosswalkConfig || (storeData && storeData.crosswalkConfig)
      if (pixelConfigSource && this.videoSrcWidth > 0 && this.videoSrcHeight > 0) {
        const pixelConfig = pixelConfigSource
        console.log('parseData - crosswalkConfig from originalPixelCrosswalkConfig:', JSON.stringify(pixelConfig))
        console.log('parseData - videoSrcWidth:', this.videoSrcWidth, 'videoSrcHeight:', this.videoSrcHeight)
        // Convert zones
        if (pixelConfig.zones && pixelConfig.zones.length > 0) {
          loadedCrosswalkConfig.zones = pixelConfig.zones.map(zone => {
            const newZone = { ...zone }
            if (zone.polygon) {
              newZone.polygon = zone.polygon.map(p => [
                parseFloat((p[0] / this.videoSrcWidth).toFixed(6)),
                parseFloat((p[1] / this.videoSrcHeight).toFixed(6))
              ])
            }
            if (zone.lines) {
              newZone.lines = zone.lines.map(line => [
                [parseFloat((line[0][0] / this.videoSrcWidth).toFixed(6)), parseFloat((line[0][1] / this.videoSrcHeight).toFixed(6))],
                [parseFloat((line[1][0] / this.videoSrcWidth).toFixed(6)), parseFloat((line[1][1] / this.videoSrcHeight).toFixed(6))]
              ])
            }
            return newZone
          })
        }
        // Convert waiting areas
        if (pixelConfig.waitingAreas && pixelConfig.waitingAreas.length > 0) {
          loadedCrosswalkConfig.waitingAreas = pixelConfig.waitingAreas.map(area => {
            const newArea = { ...area }
            if (area.polygon) {
              newArea.polygon = area.polygon.map(p => [
                parseFloat((p[0] / this.videoSrcWidth).toFixed(6)),
                parseFloat((p[1] / this.videoSrcHeight).toFixed(6))
              ])
            }
            return newArea
          })
        }
        // Copy direction map as-is
        if (pixelConfig.directionMap) {
          loadedCrosswalkConfig.directionMap = { ...pixelConfig.directionMap }
        }
        console.log('parseData - converted crosswalkConfig:', JSON.stringify(loadedCrosswalkConfig))
      } else if (pixelConfigSource) {
        console.log('parseData - skipping crosswalkConfig conversion (videoSrcWidth=0), will convert when video loads. Cached config available:', !!this.originalPixelCrosswalkConfig)
      }

      this.videoData = {
        stagePolygons: [],
        directionPolygons: [],
        trafficLightPolygons: [],
        dwellPolygons: [],
        speedLines: [],
        eventLines: [],
        approaches: [],
        measurements: [],
        geoLines: storeData ? storeData.geoLines : null,
        crossingDistanceGeoLines: storeData ? storeData.crossingDistanceGeoLines : null,
        speedDistances: storeData ? storeData.speedDistances : [],
        crosswalkConfig: loadedCrosswalkConfig
      }

      if (storeData === null) {
        this.$refs.videoDraw.setInputData([])
        return
      }

      console.log('Video json 3: ', this.videoData)

      if (storeData) {
        if (storeData.stagePolygons) {
          storeData.stagePolygons.forEach((polygon, index) => {
            let coordinates = []
            polygon.pts.forEach(pt => {
              console.log('pt:', pt[1])
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.STAGE_POLYGON}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.STAGE_POLYGON
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.stagePolygons.push({
              id: merged.id,
              storeData: {
                polyName: polygon.polyName,
                crossingDistance: polygon.crossingDistance,
                pts: polygon.pts,
              },
              ptsString: JSON.stringify(polygon.pts),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.directionPolygons) {
          storeData.directionPolygons.forEach((polygon, index) => {
            let coordinates = []
            polygon.pts.forEach(pt => {
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.DIRECTION_POLYGON}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.DIRECTION_POLYGON
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.directionPolygons.push({
              id: merged.id,
              storeData: {
                polyName: polygon.polyName,
                pts: polygon.pts,
              },
              ptsString: JSON.stringify(polygon.pts),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.trafficLightPolygons) {
          storeData.trafficLightPolygons.forEach((polygon, index) => {
            let coordinates = []
            polygon.pts.forEach(pt => {
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.TRAFFIC_LIGHT_POLYGON}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.TRAFFIC_LIGHT_POLYGON
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.trafficLightPolygons.push({
              id: merged.id,
              storeData: {
                polyName: polygon.polyName,
                pts: polygon.pts,
              },
              ptsString: JSON.stringify(polygon.pts),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.dwellPolygons) {
          storeData.dwellPolygons.forEach((polygon, index) => {
            let coordinates = []
            polygon.pts.forEach(pt => {
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.DWELL_POLYGON}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.DWELL_POLYGON
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.dwellPolygons.push({
              id: merged.id,
              storeData: {
                pedDirection: polygon.pedDirection,
                pts: polygon.pts,
              },
              ptsString: JSON.stringify(polygon.pts),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.speedLines) {
          storeData.speedLines.forEach((lineData, index) => {
            let coordinates = []
            lineData.line.forEach(pt => {
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.SPEED_LINE}_${lineData.approach}_${index}`,
              index: index,
              approach: lineData.approach,
              type: 'line',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.SPEED_LINE
            }

            let merged = Object.assign(drawData, settings)

            console.log('Video json 5: ', this.videoData.speedLines)

            if (selectedCategory === 'none' || (this.selectedApproach && lineData.approach === this.selectedApproach.key)) {
              this.videoData.speedLines.push({
                id: merged.id,
                index: index,
                storeData: {
                  approach: lineData.approach,
                  line: lineData.line,
                },
                ptsString: JSON.stringify(lineData.line),
                drawData: merged,
                originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
              })
            }

          })

        }
        if (storeData.eventLines) {
          console.log('Store Data Event lines: ', storeData.eventLines)
          storeData.eventLines.forEach((eventLine, index) => {
            let coordinates = []
            eventLine.forEach(pt => {
              console.log('pt:', pt[1])
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.EVENT_LINE}_${index}`,
              type: 'line',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.EVENT_LINE
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.eventLines.push({
              id: merged.id,
              storeData: eventLine,
              ptsString: JSON.stringify(eventLine),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.approaches) {
          console.log('Parse approaches', storeData.approaches)
          storeData.approaches.forEach((approach, index) => {

            let value = Object.values(approach)[0]
            let key = Object.keys(approach)[0]

            let point = {
              x: Math.round(value[0] * diffX),
              y: Math.round(value[1] * diffY)
            }
            let drawData = {
              id: `${VideoCalibrationCategory.APPROACH}_${index}`,
              type: 'dot',
              from: point,
              coordinates: [],
              text: key,
              textPosition: point,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.APPROACH
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.approaches.push({
              id: merged.id,
              storeData: approach,
              key: key,
              value: JSON.stringify(value),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
      }

      console.log('Test1: ', this.videoData)

      this.setMeasurements()

      let allDrawData = [
        ...this.videoData.stagePolygons.map(poly => poly.drawData),
        ...this.videoData.directionPolygons.map(poly => poly.drawData),
        ...this.videoData.trafficLightPolygons.map(poly => poly.drawData),
        ...this.videoData.dwellPolygons.map(poly => poly.drawData),
        ...this.videoData.speedLines.map(line => line.drawData),
        ...this.videoData.eventLines.map(eLine => eLine.drawData),
        ...this.videoData.approaches.map(app => app.drawData),
        ...this.videoData.measurements
      ]

      console.log('All DATA: ', allDrawData)
      console.log('All DATA: ', allDrawData)
      this.$refs.videoDraw.setInputData(allDrawData)

      this.setDirectionLookup()
    },
    setMeasurements() {

      let currentWidth = this.$refs.videoDraw.getSize().width
      let currentHeight = this.$refs.videoDraw.getSize().height

      let settings = this.$refs.videoDraw.getSettings()

      //add line measurements
      this.videoData.measurements = []


      let groupedLines = this.videoData.speedLines.reduce((acc, item) => {
        const key = item.storeData.approach;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      console.log('Grouped lines: ', groupedLines)

      Object.keys(groupedLines).forEach(approach => {

        const distIndex = this.storeData.speedDistances.findIndex(dst => dst.approach === approach)
        console.log('Speed distances for: ', approach, this.storeData.speedDistances)

        if (distIndex !== -1) {
          const distance = this.storeData.speedDistances[distIndex].distances
          for (let i = 0; i < groupedLines[approach].length - 1; i++) {

            let first = groupedLines[approach][i].drawData.from
            let second = groupedLines[approach][i + 1].drawData.from

            let middleX = (first.x + second.x) / 2
            let middleY = (first.y + second.y) / 2


            const distIndex = this.storeData.speedDistances.findIndex(dst => dst.approach === approach)
            console.log('Speed distances for: ', approach, this.storeData.speedDistances)
            if (distIndex !== -1) {

              console.log('Find distance: ', distance)
              let measureLine = {
                id: `measure_${i}`,
                approach: approach,
                type: 'line',
                from: first,
                coordinates: [second],
                text: distance && distance.length > i ? distance[i] + ' m' : 'NOT MEASURED',
                textPosition: {x: middleX, y: middleY},
                renderedDimensions: {width: currentWidth, height: currentHeight},
                category: 'measurement_line'
              };

              let merged = Object.assign(measureLine, settings)
              merged.color = '#ffdb00'
              merged.width = 3
              this.videoData.measurements.push(merged)
            }
          }
        }
      })
      console.log('Measurement lines:', this.videoData.measurements)
    },
    onDeleteImage(imageId) {
      console.log('On delete image', imageId)
      let polyIndex = this.videoData.stagePolygons.findIndex(poly => poly.id === imageId)
      if (polyIndex !== -1) {
        this.videoData.stagePolygons.splice(polyIndex, 1)
        this.$refs.mapDraw.deleteFeature(polyIndex)
      }

      let dirIndex = this.videoData.directionPolygons.findIndex(poly => poly.id === imageId)
      if (dirIndex !== -1) {
        this.videoData.directionPolygons.splice(dirIndex, 1)
      }

      let tlIndex = this.videoData.trafficLightPolygons.findIndex(poly => poly.id === imageId)
      if (tlIndex !== -1) {
        this.videoData.trafficLightPolygons.splice(tlIndex, 1)
      }

      let dwellIndex = this.videoData.dwellPolygons.findIndex(poly => poly.id === imageId)
      if (dwellIndex !== -1) {
        this.videoData.dwellPolygons.splice(dwellIndex, 1)
      }

      let speedLineIndex = this.videoData.speedLines.findIndex(line => line.id === imageId)
      if (speedLineIndex !== -1) {
        this.videoData.speedLines.splice(speedLineIndex, 1)
        this.$refs.mapDraw.deleteFeature(speedLineIndex)
        this.setMeasurements()

      }
      let eLineIndex = this.videoData.eventLines.findIndex(l => l.id === imageId)
      if (eLineIndex !== -1) {
        this.videoData.eventLines.splice(eLineIndex, 1)
      }
      let aIndex = this.videoData.approaches.findIndex(a => a.id === imageId)
      if (aIndex !== -1) {
        this.videoData.approaches.splice(aIndex, 1)
      }

      this.refreshData()


    },
    onDrawFinished(images) {
      console.log('On draw finished', images)

      let diffX = this.videoSrcWidth / this.$refs.videoDraw.getSize().width
      let diffY = this.videoSrcHeight / this.$refs.videoDraw.getSize().height
      //check is deleted


      images.forEach(image => {

        if (image.category === VideoCalibrationCategory.STAGE_POLYGON) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.stagePolygons.findIndex(poly => poly.id === image.id)
          if (index !== -1) {
            this.videoData.stagePolygons[index].drawData = image
            this.videoData.stagePolygons[index].pts = pts
          } else {

            let crossingDistance = null

            if (this.videoData.crossingDistanceGeoLines && this.videoData.crossingDistanceGeoLines.features
                && this.videoData.crossingDistanceGeoLines.features.length > 0) {

              let featureIndex = this.videoData.crossingDistanceGeoLines.features.findIndex(feature => feature.id === image.id)
              if (featureIndex !== -1) {
                let options = {units: "kilometers"};
                let coordinates = this.videoData.crossingDistanceGeoLines.features[featureIndex].geometry.coordinates
                let dist = distance(point(coordinates[0]), point(coordinates[1]), options);
                crossingDistance = (dist * 1000.0).toFixed(3)
              }
            }

            this.videoData.stagePolygons.push(
                {
                  id: image.id,
                  storeData: {
                    polyName: null,
                    crossingDistance: crossingDistance,
                    pts: pts,
                  },
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.DIRECTION_POLYGON) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.directionPolygons.findIndex(poly => poly.id === image.id)
          if (index !== -1) {
            this.videoData.directionPolygons[index].drawData = image
            this.videoData.directionPolygons[index].pts = pts
          } else {
            this.videoData.directionPolygons.push(
                {
                  id: image.id,
                  storeData: {
                    polyName: null,
                    pts: pts,
                  },
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.TRAFFIC_LIGHT_POLYGON) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.trafficLightPolygons.findIndex(poly => poly.id === image.id)
          if (index !== -1) {
            this.videoData.trafficLightPolygons[index].drawData = image
            this.videoData.trafficLightPolygons[index].pts = pts
          } else {
            this.videoData.trafficLightPolygons.push(
                {
                  id: image.id,
                  storeData: {
                    polyName: null,
                    pts: pts,
                  },
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.DWELL_POLYGON) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.dwellPolygons.findIndex(poly => poly.id === image.id)
          if (index !== -1) {
            this.videoData.dwellPolygons[index].drawData = image
            this.videoData.dwellPolygons[index].pts = pts
          } else {
            this.videoData.dwellPolygons.push(
                {
                  id: image.id,
                  storeData: {
                    pedDirection: null,
                    pts: pts,
                  },
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.SPEED_LINE) {
          console.log('SPEED LINE IMG: ', image)
          //console.log('SPEED LINE IMG: ', this.videoData.speedLines)
          let points = []
          points.push(image.from)
          if(image.coordinates && image.coordinates.length > 0){
            points.push(...image.coordinates)
            let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
            let index = this.videoData.speedLines.findIndex(line => line.id === image.id)
            if (index !== -1) {
              console.log('SPEED LINE IMG Find index: ', this.videoData.speedLines[index].storeData)
              console.log('SPEED LINE IMG New pts: ', pts)
              this.videoData.speedLines[index].drawData = image
              this.videoData.speedLines[index].line = pts
            } else {
              this.videoData.speedLines.push(
                  {
                    id: image.id,
                    storeData: {
                      approach: this.selectedApproach.key,
                      line: pts,
                    },
                    drawData: image,
                    originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                  }
              )
            }
          }

        } else if (image.category === VideoCalibrationCategory.EVENT_LINE) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.eventLines.findIndex(line => line.id === image.id)
          if (index !== -1) {
            this.videoData.eventLines[index].drawData = image
            this.videoData.eventLines[index].storeData = pts
          } else {
            this.videoData.eventLines.push(
                {
                  id: image.id,
                  storeData: pts,
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.APPROACH) {
          let pts = [Math.round(image.from.x * diffX), Math.round(image.from.y * diffY)]
          let obj = {}
          obj[image.text] = pts


          let index = this.videoData.approaches.findIndex(app => app.id === image.id)
          if (index !== -1) {
            this.videoData.approaches[index].drawData = image
            this.videoData.approaches[index].storeData = obj
          } else {
            this.videoData.approaches.push({
              id: image.id,
              storeData: obj,
              drawData: image,
              key: image.text,
              value: JSON.stringify(pts),
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          }
        } else if (image.category === VideoCalibrationCategory.CROSSWALK_ZONE ||
                   image.category === VideoCalibrationCategory.WAITING_AREA) {
          // Handle crosswalk zone and waiting area polygons
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)

          // Debug: log points and dimensions
          console.log('Crossing/Waiting draw - raw points:', JSON.stringify(points))
          console.log('Crossing/Waiting draw - canvas size:', this.$refs.videoDraw.getSize())

          // Convert to relative coordinates (0-1)
          let relativePoints = points.map(point => [
            parseFloat((point.x / this.$refs.videoDraw.getSize().width).toFixed(6)),
            parseFloat((point.y / this.$refs.videoDraw.getSize().height).toFixed(6))
          ])
          console.log('Crossing/Waiting draw - relative points:', JSON.stringify(relativePoints))

          // Store temporarily for geo mapping
          this.crossingPendingPolygon = {
            category: image.category,
            polygon: relativePoints,
            drawData: image
          }

          // Notify crossing-config component
          if (this.$refs.crossingConfig) {
            this.$refs.crossingConfig.setVideoPolygon(relativePoints)
          }

          // Only switch to map for crosswalk zones, not waiting areas
          if (image.category === VideoCalibrationCategory.CROSSWALK_ZONE) {
            // Switch to map view for geo point collection
            this.crossingViewMode = 'map'
            this.$refs.mapDraw.enableCrossingClickMode(true)

            this.$buefy.toast.open({
              message: `Polygon drawn with ${relativePoints.length} points. Now click the same points on the map.`,
              type: 'is-info',
              duration: 4000
            })
          }
        }
      })

      console.log('New video data: ', this.videoData)
      this.setStoreData()
      this.parseData(this.storeData)
    },
    onTabChanged(index) {
      console.log('On tab changed: ', index)

      // Clear crossing zones when leaving Tab 4 (Crossing Config)
      if (index !== 4) {
        this.clearAllCrossingZones()
      }

      if (index === 0) {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.STAGE_POLYGON)
        // Ensure MapboxDraw is properly added for Stage Polygons tab - pass tab index directly
        this.$nextTick(() => {
          if (this.$refs.mapDraw) {
            console.log('onTabChanged - explicitly calling addOrRemoveDraw for Stage Polygons tab with index:', index)
            this.$refs.mapDraw.addOrRemoveDraw(index)
          }
        })
      } else if (index === 1) {
        this.$refs.videoDraw.setSelectedCategory('dot', VideoCalibrationCategory.APPROACH)
        // Remove MapboxDraw for this tab
        this.$nextTick(() => {
          if (this.$refs.mapDraw) this.$refs.mapDraw.addOrRemoveDraw(index)
        })
      } else if (index === 2) {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.DIRECTION_POLYGON)
        // Remove MapboxDraw for this tab
        this.$nextTick(() => {
          if (this.$refs.mapDraw) this.$refs.mapDraw.addOrRemoveDraw(index)
        })
      } else if (index === 3) {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.TRAFFIC_LIGHT_POLYGON)
        // Remove MapboxDraw for this tab
        this.$nextTick(() => {
          if (this.$refs.mapDraw) this.$refs.mapDraw.addOrRemoveDraw(index)
        })
      } else if (index === 4) {
        // Crossing Config tab - set category based on current mode
        this.crossingViewMode = 'video'
        this.$nextTick(() => {
          // Remove MapboxDraw for this tab
          if (this.$refs.mapDraw) this.$refs.mapDraw.addOrRemoveDraw(index)

          if (this.$refs.crossingConfig) {
            const mode = this.$refs.crossingConfig.getCurrentMode()
            if (mode === 'waiting') {
              this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.WAITING_AREA)
            } else {
              this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.CROSSWALK_ZONE)
            }
          } else {
            this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.CROSSWALK_ZONE)
          }
          // Draw existing zones when entering Tab 4
          this.drawAllCrossingZones()
        })
      } else if (index === 5) {
        this.$refs.videoDraw.setSelectedCategory('line', VideoCalibrationCategory.SPEED_LINE)
        // Ensure MapboxDraw is properly added for Speed Lines tab - pass tab index directly
        this.$nextTick(() => {
          if (this.$refs.mapDraw) {
            console.log('onTabChanged - explicitly calling addOrRemoveDraw for Speed Lines tab with index:', index)
            this.$refs.mapDraw.addOrRemoveDraw(index)
          }
        })
      } else {
        this.$refs.videoDraw.setSelectedCategory('none', 'none')
        // Remove MapboxDraw for any other tab
        this.$nextTick(() => {
          if (this.$refs.mapDraw) this.$refs.mapDraw.addOrRemoveDraw(index)
        })
      }
    },
    // Crossing Config Methods
    setCrossingViewMode(mode) {
      // Waiting areas are video-only, don't allow map view
      if (mode === 'map' && this.$refs.crossingConfig && this.$refs.crossingConfig.currentMode === 'waiting') {
        return
      }
      this.crossingViewMode = mode
      if (mode === 'map' && this.$refs.crossingConfig && this.$refs.crossingConfig.isInMapDrawingPhase()) {
        // Enable map click mode for crossing only when in map drawing phase
        this.$refs.mapDraw.enableCrossingClickMode(true)
      } else {
        this.$refs.mapDraw.enableCrossingClickMode(false)
      }
    },
    getCrossingStepLabel() {
      if (!this.$refs.crossingConfig) return 'Video'
      const phase = this.$refs.crossingConfig.drawingPhase
      if (phase === 'video') return 'Video'
      if (phase === 'map') return 'Map'
      return 'Complete'
    },
    onCrossingVideoPointsChanged(points, color) {
      console.log('Crossing video points changed:', points, color)
      // Draw current points on video canvas
      this.drawCrossingPointsOnVideo(points, color)
    },
    onCrossingMapPointsChanged(points, color) {
      console.log('Crossing map points changed:', points, color)
      // Draw current points on map
      this.$refs.mapDraw.drawCrossingPoints(points, color)
    },
    onCrossingDrawingReset() {
      console.log('Crossing drawing reset')
      // Clear only the temporary overlay (not saved zones)
      if (this.$refs.videoDraw) {
        this.$refs.videoDraw.clearCrossingOverlay()
      }
      if (this.$refs.mapDraw) {
        this.$refs.mapDraw.clearCrossingPoints()
      }
      // Clear pending polygon
      this.crossingPendingPolygon = null
      // Disable map click mode
      this.$refs.mapDraw.enableCrossingClickMode(false)
      // Switch view back to video
      this.crossingViewMode = 'video'
      // Redraw all saved zones (only if on Tab 4)
      if (this.tabIndex === 4) {
        this.$nextTick(() => {
          this.drawAllCrossingZones()
        })
      }
    },
    onCrossingConfigChanged(config) {
      console.log('Crossing config changed:', config)
      this.videoData.crosswalkConfig = config
      this.setStoreData()
      // Redraw all zones to show newly saved/updated zones (only if on Tab 4)
      if (this.tabIndex === 4) {
        this.$nextTick(() => {
          this.drawAllCrossingZones()
        })
      }
    },
    onCrossingRedrawRequired() {
      console.log('Crossing redraw required')
      // Only redraw if on Tab 4
      if (this.tabIndex === 4) {
        this.drawAllCrossingZones()
      }
    },
    loadCrossingConfigOnMount() {
      // Load existing crosswalkConfig into crossing-config component (but don't draw yet)
      if (this.videoData.crosswalkConfig &&
          (this.videoData.crosswalkConfig.zones.length > 0 ||
           this.videoData.crosswalkConfig.waitingAreas.length > 0)) {
        console.log('Loading existing crosswalkConfig:', this.videoData.crosswalkConfig)
        this.$nextTick(() => {
          if (this.$refs.crossingConfig) {
            this.$refs.crossingConfig.loadConfig(this.videoData.crosswalkConfig)
          }
          // Only draw if currently on Tab 4
          if (this.tabIndex === 4) {
            this.drawAllCrossingZones()
          }
        })
      }
    },
    onCrossingModeChanged(mode) {
      console.log('Crossing mode changed:', mode)
      // Update the draw category based on the crossing mode
      if (mode === 'crosswalk') {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.CROSSWALK_ZONE)
      } else if (mode === 'waiting') {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.WAITING_AREA)
        // Waiting areas are video-only, force video view
        this.crossingViewMode = 'video'
        // Disable map click mode
        if (this.$refs.mapDraw) {
          this.$refs.mapDraw.enableCrossingClickMode(false)
        }
      }
    },
    drawCrossingPointsOnVideo(points, color) {
      if (!this.$refs.videoDraw || !points) return

      // Convert relative coords to canvas coords
      const size = this.$refs.videoDraw.getSize()
      const canvasPoints = points.map((p, index) => ({
        x: Math.round(p[0] * size.width),
        y: Math.round(p[1] * size.height),
        index: index + 1
      }))

      // Call draw method on videoDraw with crossing points
      this.$refs.videoDraw.drawCrossingOverlay(canvasPoints, color)
    },
    clearCrossingDrawings() {
      if (this.$refs.videoDraw) {
        this.$refs.videoDraw.clearCrossingOverlay()
      }
      if (this.$refs.mapDraw) {
        this.$refs.mapDraw.clearCrossingPoints()
      }
    },
    clearAllCrossingZones() {
      // Clear all crossing zone drawings from video and map (used when leaving tab)
      if (this.$refs.videoDraw) {
        this.$refs.videoDraw.clearAllCrossingData()
      }
      if (this.$refs.mapDraw) {
        this.$refs.mapDraw.clearCrossingPoints()
        this.$refs.mapDraw.clearCrossingZoneLayers()
        // Disable crossing click mode so it doesn't interfere with other tabs
        this.$refs.mapDraw.enableCrossingClickMode(false)
      }
    },
    drawAllCrossingZones() {
      // Redraw all saved zones and waiting areas
      let config = null
      if (this.$refs.crossingConfig) {
        config = this.$refs.crossingConfig.getConfig()
      } else if (this.videoData.crosswalkConfig) {
        // Fallback to videoData if crossing-config not yet available
        config = this.videoData.crosswalkConfig
      }

      if (config) {
        // Draw on video canvas
        if (this.$refs.videoDraw) {
          this.$refs.videoDraw.drawAllCrossingZones(config.zones || [], config.waitingAreas || [])
        }
        // Draw on map
        if (this.$refs.mapDraw) {
          this.$refs.mapDraw.drawAllCrossingZones(config.zones || [], config.waitingAreas || [])
        }
      }
    },
    // Handle canvas click for crossing mode
    onCrossingCanvasClick(relX, relY) {
      if (this.tabIndex !== 4) return
      if (!this.$refs.crossingConfig) return
      if (!this.$refs.crossingConfig.isInVideoDrawingPhase()) return

      this.$refs.crossingConfig.addVideoPoint(relX, relY)
    },
    // Handle map click for crossing mode
    onCrossingMapClick(lng, lat) {
      if (this.tabIndex !== 4) return
      if (!this.$refs.crossingConfig) return
      if (!this.$refs.crossingConfig.isInMapDrawingPhase()) return

      this.$refs.crossingConfig.addMapPoint(lng, lat)
    },
    onVideoMetaDataLoaded(e) {
      this.videoSrcWidth = e.target.videoWidth
      this.videoSrcHeight = e.target.videoHeight
      console.log('Width&Height of video', this.videoSrcWidth, this.videoSrcHeight)
      this.$refs.videoDraw.setOriginalVideoDimensions(this.videoSrcWidth, this.videoSrcHeight)
      this.isLoading = false
      this.videoLoaded = true
      //this.$refs.videoRef.play()
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    onCloneCalibration(calibration) {
      this.$refs.actionsBar.cloneCalibration(calibration)
    },
    async onEditCalibration(calibration) {
      console.log('Calibration: ', calibration)
      let calib = JSON.parse(JSON.stringify(calibration))
      calib.isNew = true
      calib.isEdit = true
      await this.selectCalibration(calib)
    }
  },
  computed: {
    ...mapGetters({
      calibrations: 'dataProcessingTmcModule/getTmcSelectedVideoCalibrations',
      selectedCalibration: 'dataProcessingTmcModule/getTmcSelectedCalibration',
      selectedDevice: 'dataProcessingTmcModule/getTmcSelectedProcessingDevice',
      allProjects: 'projectsModule/getAllProjects',
      selectedProject: 'dataProcessingTmcModule/getTmcSelectedProcessingProject',
    }),
  },
  watch: {
    selectedCalibration() {
      console.log('Selected calibration: ', this.selectedCalibration)
      this.convertAndSetData()
      this.parseData(this.storeData)
      this.$refs.mapDraw.setFeature(this.storeData && this.selectedApproach ? this.storeData.geoLines[this.selectedApproach.key] : null)
      this.$refs.mapDraw.setCrossingDistanceFeature(this.storeData ? this.storeData.crossingDistanceGeoLines : null)
      this.$refs.mapDraw.addOrRemoveDraw()

      if (this.selectedCalibration && this.$refs.videoRef.src !== this.selectedCalibration.videoUrl) {
        this.isLoading = true
        this.videoLoaded = false
        this.$refs.videoRef.src = this.selectedCalibration.videoUrl
      } else if (this.$refs.videoRef && this.$refs.videoRef.src !== this.selectedDevice.videoUrl) {
        this.isLoading = true
        this.videoLoaded = false
        this.$refs.videoRef.src = this.selectedDevice.videoUrl
      } else if (this.videoSrcWidth > 0 && this.videoSrcHeight > 0) {
        // Video URL is the same, video already loaded - reload crossing config
        this.loadCrossingConfigOnMount()
      }
    }
  }
}
</script>

<style scoped>
.video-img {
  background: white;
}

.canvas-style {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
}

.shadow {
  box-shadow: 0 0.125em 0.125em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 14%);
}

</style>